import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import withLazyLoad from 'utils/withLazyLoad';
import ui from 'stores/ui';
import withPid from 'utils/withPid';

import './style.scss';

class AboutUs extends Component {
    componentDidMount() {
        this.changeNavMode();
        window.addEventListener('resize', this.changeNavMode, false);
        window.addEventListener('scroll', this.changeNavMode, false);
    }

    componentWillUnmount() {
        ui.setNavTheme('default');
        window.removeEventListener('resize', this.changeNavMode, false);
        window.removeEventListener('scroll', this.changeNavMode, false);
    }

    changeNavMode = () => {
        const navTheme = window.pageYOffset > 5 ? 'default' : 'primary';

        ui.setNavTheme(navTheme);
    };

    render() {
        return (
            <div className="page-aboutus">
                <Helmet>
                    <title>About Online Trading Platform TradeUP</title>
                    <meta
                        name="description"
                        content="TradeUP is a feature-rich mobile trading application designed for investors to access equity markets and build global investment portfolios. Learn More!"
                    />
                </Helmet>
                <div className="banner">
                    <div className="banner-info site-main">
                        <div className="banner-title a-flyTopIn">
                            <h3>
                                TradeUP is a feature-rich mobile trading application designed for investors to access
                                equity markets and build global investment portfolios. By leveraging our innovative
                                technology, users may seize investment opportunities anytime, anywhere.
                            </h3>
                            <h3 className="text">
                                Brokerage services in TradeUP are offered byTradeUP Securities, Inc. which is a
                                broker-dealer registered with the SEC and member of FINRA and SIPC. You may check the
                                background of TradeUP Securities, Inc.{' '}
                                <a
                                    className="white-link d-inline-block"
                                    href="https://brokercheck.finra.org/firm/summary/18483"
                                    target="_blank">
                                    {' '}
                                    FINRA's BrokerCheck{' '}
                                </a>
                            </h3>
                        </div>
                    </div>
                </div>
                <section className="contact section">
                    <div className="site-main aninode">
                        <div data-animation="a-flyRightIn">
                            <h2 className="contact-title">Contact Us</h2>
                            <p>Address: 437 MADISON AVE , 27TH FLOOR , NEW YORK, NY 10022 USA</p>
                            <p>
                                Email:{' '}
                                <a className="email" href="mailto:support@tradeup.com ">
                                    support@tradeup.com{' '}
                                </a>
                            </p>
                            <p>
                                Fax: <a href="tel:(973)-228-9762">(973)-228-9762</a>
                            </p>
                            <p>Office Hours: Monday 9am (EST) to Friday 5pm (EST)</p>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default withLazyLoad(withPid('aboutus')(AboutUs));
